export const prefix = "bat"
export const iconName = "check"
export const width = 19
export const height = 14
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M18.3232 0H16.7813C16.5652 0 16.36 0.0978488 16.2277 0.265279L7.13318 11.6223L2.77233 6.17535C2.70636 6.09279 2.62227 6.02602 2.52638 5.98008C2.43049 5.93413 2.32529 5.9102 2.21867 5.91007H0.67682C0.529032 5.91007 0.447418 6.0775 0.537855 6.19057L6.57953 13.7358C6.86187 14.0881 7.40449 14.0881 7.68904 13.7358L18.4621 0.278326C18.5526 0.16743 18.471 0 18.3232 0Z"

export const definition = {
    prefix,
    iconName,
    icon: [width, height, ligatures, unicode, svgPathData],
}

export const batCheck = definition
